import { Button } from "@/shared/ui/button";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { useAuth } from "@/features/auth/model/AuthContext";

export function Unauthorized() {
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    navigate("/auth");
  }

  return (
    <div className="min-h-screen bg-[#0F0F0F] flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-md p-8 bg-[#1E1E1E] rounded-xl border border-red-500/20 shadow-lg">
        <div className="flex flex-col items-center text-center space-y-6">
          <div className="p-4 bg-red-500/10 rounded-full">
            <AlertCircle className="w-12 h-12 text-red-500" strokeWidth={1.5} />
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-white">Acesso Restrito</h1>
            <p className="text-gray-400 text-sm">
              Você não tem permissão para acessar este recurso.
            </p>
          </div>

          <div className="w-full border-t border-gray-800 my-4"></div>

          <p className="text-sm text-gray-400">
            Se você acredita que isso é um erro, entre em contato com o suporte ou seu administrador.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 w-full mt-6">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="w-full bg-transparent hover:bg-gray-800 text-white border-gray-700 hover:border-gray-600"
            >
              Voltar
            </Button>
            <Button
              onClick={() => navigate('/')}
              className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white"
            >
              Ir para o Início
            </Button>
          </div>
          <Button
            onClick={() => logout()}
            className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white"
          >
            Sair
          </Button>
        </div>
      </div>

      <p className="mt-8 text-xs text-gray-500 text-center max-w-md">
        Código de erro: <span className="font-mono bg-gray-800 px-2 py-1 rounded">403 Forbidden</span>
      </p>
    </div>
  );
}
